export default __webpack_public_path__ + "static/media/time.4abee5e5.svg";